<template>
  <nav
    class="pb-3"
    ref="nav"
    :class="{ fixed, roundedTopLeft }"
  >
    <h4
      class="filter-title"
      v-if="title"
      v-once
    >
      {{ title }}
    </h4>
    <ul class="nav flex-column">
      <li
        class="nav-item"
        v-for="(field, name) in filtered"
        :key="name"
      >
        <a
          href="#"
          :class="['nav-link', { active: name == current }]"
          @click.prevent="toggle(name)"
        >
          {{ __(field.title) }}
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    scrollfix: {
      type: Boolean,
      default: false,
    },
    fields: {
      type: Object,
      required: true,
      validator (obj) {
        return !! obj.default;
      },
    },
    title: String,
  },

  data () {
    return {
      current: 'default',
      fixed: false,
      roundedTopLeft: false,
    };
  },

  mounted () {
    document.addEventListener('scroll', this.anchor);
    Bus.$on('AsideMenuActive', (category) => this.current = category);
  },

  computed: {
    filtered () {
      return Object.keys(this.fields).filter((field) => {
        if (! this.fields[field].validate) {
          return true;
        }

        return this.fields[field].validate();
      }).reduce((obj, key) => Object.assign(obj, { [key]: this.fields[key] }), {});
    },
  },

  methods: {
    toggle (event) {
      if (this.current != event) {
        this.current = event;
        Bus.$emit('AsideActive', event);
      }
    },

    anchor (a, b, c) {
      if (! this.scrollfix) {
        return;
      }

      const offset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

      if (! this.fixed && offset >= 100) {
        this.fixed = true;
        this.roundedTopLeft = true;
      }

      if (this.fixed && offset <= 100) {
        this.fixed = false;
        this.roundedTopLeft = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  nav {
    width: inherit;
    background-color: #ffffff;
    box-shadow: 0 5px 20px rgba(103, 70, 162, 0.18);
    border-radius: 0 0 0 20px;
  }

  h4,
  .nav-link {
    color: #3b334a;
    font-size: 12px;
    font-weight: 400;
    letter-spacing: -0.18px;
    line-height: 40px;
  }

  h4 {
    margin: 0;
    padding: 20px;
  }

  .nav-link {
    padding: 5px 15px;
    height: 48px;

    &.active {
      background-color: #f6f5f8;
    }
  }

  i {
    margin-right: 5px;
  }

  .fixed {
    top: 65px;
    position: fixed;
  }

  .filter-title {
    font-weight: 400;
    line-height: 30px;
    letter-spacing: -0.27px;
    color: #3b334a;
    text-align: center;
    font-size: 18px;
  }

  .roundedTopLeft {
    border-radius: 20px 0 0 20px;
  }
</style>
